<template>

<app-page :loading="is.loading">

	<app-page-head title="Templates" :count="generatedList.length">

		<app-page-head-search v-model="searchText" :count="generatedList.length" />

		<template v-if="$permission('full')">

			<app-page-head-action route="Template" :params="{ template: 'new' }" icon="create" tooltip="Add template" v-if="tab === 'templates'" />

		</template>
		
	</app-page-head>

	<div class="tabs">

		<div class="tabs-item" :class="{'is-active': tab === 'templates'}" v-on:click="tab = 'templates'">Templates</div>
		<div class="tabs-item" :class="{'is-active': tab === 'blocks'}" v-on:click="tab = 'blocks'">v1 Content</div>

	</div>

	<app-page-content :is-empty="!list.length" empty-message="No templates found." class="tabs-content" v-if="tab === 'templates'">

		<com-template v-for="item in list" :key="item.id" :item="item" :highlight="searchText" :selected="isSelected(item.id)" v-on:shiftclick="onSelectClick(item.id)" />

	</app-page-content>

	<app-page-content :is-empty="!list.length" :empty-message="(searchText || !mustSearch) ? 'No blocks found.' : 'Search blocks...'" :allowSearch="mustSearch" class="tabs-content" v-if="tab === 'blocks'" v-on:search="onSearch">

		<com-block v-for="item in list" :key="item.id" :item="item" :highlight="searchText" :selected="isSelected(item.id)" v-on:shiftclick="onSelectClick(item.id)" />

	</app-page-content>

	<app-page-foot />

</app-page>

</template>

<script>

import mixList from '@/mixin/list'

export default {

	mixins: [mixList],

	components: {
		'com-template': () => import('./templates/Item'),
		'com-block': () => import('./texts/Item')
	},

	data: function() {

		return {
			tab: 'templates'
		}

	},

	watch: {

		tab: function(n) {

			this.$store.commit('remember', {
				path: this.$route.path,
				name: 'tab',
				value: n
			})

		}

	},

	computed: {

		generatedList: function() {

			return (this.tab === 'templates') ? this.data.templates || [] : this.$store.getters['texts']

		},

		mustSearch: function() {

			return (this.tab === 'templates') ? false : this.generatedList.length > 100

		}

	},

	methods: {

		onSearch: function(value) {

			this.searchText = value

		},

		search: function(value) {

			var match = false

			if (this.tab === 'templates') {

				match = this.$util.search(value.name, this.searchText) 

				if(match === false) {

					var matches = this.$_.filter(value.content, function(content) {

						return this.$_.filter(content.blocks, function(block) {

							return this.$util.search(block.content || '', this.searchText) 

						}.bind(this)).length

					}.bind(this))

					if (matches.length) match = true

				}

			} else {

				match = this.$util.search(value.title, this.searchText) 

				if(match === false) {

					match = this.$util.search(value.content, this.searchText) 

				}

			}

			return match

		},

		load: function() {

			this.is.loading = true
	
			this.tab = this.$store.getters['remember'](this.$route.path, 'tab', 'templates')

			this.$api.get('templates').then(function(response) {

				this.$vueset(this, 'data', response)

				this.is.loading = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

.tabs {
	border-bottom: 1px solid #eee;
	padding: 0px 10px!important;
	display: flex;
	height: 39px;
	margin-top: 20px;
}

.tabs-item {
	font-size: 16px;
	color: #0b234e;
	height: 39px;
	line-height: 42px;
	border-radius: 4px 4px 0px 0px;
	padding: 0px 10px;
	margin-right: 4px;
	font-weight: 400;
	cursor: pointer;
	border-bottom: 1px solid #eee;
}

.tabs-item:not(.is-active):hover {
	background-color: #f7f7f7;
}

.tabs-item.is-active {
	border: 1px solid #eee;
	line-height: 40px;
	border-bottom: 1px solid #fff;
}

.tabs-content {
	padding-top: 0px;
}

</style>
